import { CLEAR_ALL } from "redux/action_types";

export function clearAll() {
  return { type: CLEAR_ALL };
}
